export var DEFAULT_SEARCH_RESULTS_REDUX = {
  metaData: {
    totalPages: 0,
    title: "",
    productsCount: 0,
    category_path: "",
    request_id: "",
    metaTags: []
  },
  posts: [],
  selectedOptions: [],
  filters: [],
  marketingBanner: {},
  search_meta: {}
};
export var DEFAULT_FILTER_PAGE_CONTEXT = {
  searchTerm: "",
  sort: "",
  page: 1,
  searchResults: DEFAULT_SEARCH_RESULTS_REDUX,
  isLoading: false,
  dispatchLoading: function dispatchLoading(val) {
    return 0;
  },
  runWhenElementViewed: function runWhenElementViewed(el) {
    return 0;
  },
  hasMorePages: function hasMorePages() {
    return false;
  },
  //showFilters
  showFilters: false,
  setShowFilters: function setShowFilters(val) {
    return 0;
  },
  //Flags
  isAutosPage: false,
  isCarCountriesPage: false,
  isYearsPage: false,
  isDealPage: false,
  //constants
  dealId: undefined,
  search_meta: {
    search_hash: "",
    title: ""
  },
  isSearchSaved: true,
  total_pages: 1,
  setPage: function setPage(val) {
    return 0;
  }
};